import { SkeletonBar, TextPassage } from '@petsmart-ui/sparky';

import { CurbsideInfoDetail, MinimumQuantityText } from '@libs/shared-ui';

import type { DeliveryDetailsContentProps } from '../../model';

export const DeliveryDetailsContent = ({
    isLoading,
    isCurbsideAvailable,
    minimumCaseQty,
    isDelivery,
}: DeliveryDetailsContentProps) => {
    if (isLoading) {
        return <SkeletonBar className="delivery-details__curbside-skeleton" />;
    }

    return (
        <>
            {isCurbsideAvailable && <CurbsideInfoDetail />}
            {isDelivery && (
                <TextPassage data-testid="delivery-window-text" className="delivery-details__delivery-window-text">
                    Select a delivery window at checkout
                </TextPassage>
            )}
            <MinimumQuantityText minimumQuantity={minimumCaseQty} />
        </>
    );
};
